import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import CustomSingleSelect, { CustomSingleSelectModel } from '../../../../components/CustomSingleSelect';
import { storeActivityIndicator, storeAreYouSureModalCallback } from '../../../../redux/reducers/authSlice';
import toast from "react-hot-toast";
import { GetConstantListResponse } from '../../../../models/response/constant/GetConstantListResponse';
import { ConstantService } from '../../../../services/ConstantService';
import { Helpers } from '../../../../helpers/Helpers';
import { GetCompanyByIdResponseCompanyBank } from '../../../../models/response/company/GetCompanyByIdResponse';
import { KTCard } from '../../../../_metronic/helpers/components/KTCard';
import { KTCardBody } from '../../../../_metronic/helpers/components/KTCardBody';
import Box from '../../../../components/Box';

interface Props {
    companyBanks: GetCompanyByIdResponseCompanyBank[]
    setCompanyBanks: React.Dispatch<React.SetStateAction<GetCompanyByIdResponseCompanyBank[]>>
    banksInformationsRef: any
    canBeEdited: boolean
}

const BanksInformations = ({
    companyBanks,
    setCompanyBanks,
    banksInformationsRef,
    canBeEdited
}: Props) => {
    const dispatch = useDispatch();
    const [companyBankId, setCompanyBankId] = useState('');
    const [iban, setIban] = useState<string | undefined>(undefined);
    const [selectedBank, setSelectedBank] = useState<CustomSingleSelectModel | undefined>(undefined);
    const [accountNo, setAccountNo] = useState<string | undefined>(undefined);
    const [selectedBankCurrencyType, setSelectedBankCurrencyType] = useState<CustomSingleSelectModel | undefined>(undefined);
    const [isOpen, setIsOpen] = useState(false);

    const onIbanChange = async () => {
        try {
            dispatch(storeActivityIndicator(true))

            var ibanVal = iban ? iban.replaceAll(" ", "").replace(/[^a-z0-9]/gi, '') : '';

            if (ibanVal.length <= 9) {
                setSelectedBank(undefined);
                setAccountNo('');
                setSelectedBankCurrencyType(undefined);
                return;
            }

            if (ibanVal.length == 26 && !selectedBank) {
                var bankCode = parseInt(ibanVal.substring(4, 9)).toString();

                var response: GetConstantListResponse = await ConstantService.getConstantList('BANK', undefined, bankCode);

                if (!response.isSuccess) {
                    toast.error(response.message)
                    return;
                }

                if (response.data.length > 0) {
                    setSelectedBank({ value: response.data[0].constantId, label: response.data[0].value });

                    var splitted = ibanVal.split('0');
                    setAccountNo(splitted[splitted.length - 1]);
                }
                else {
                    setSelectedBank(undefined);
                    setAccountNo('');
                    setSelectedBankCurrencyType(undefined);
                }
            }
        } catch (error: any) {
            toast.error(error)
        }
        finally {
            dispatch(storeActivityIndicator(false))
        }
    }

    const saveItem = () => {
        if (Helpers.isEmpty(companyBankId)) {
            var o: GetCompanyByIdResponseCompanyBank = {
                accountNo: accountNo,
                bankId: selectedBank?.value,
                bankName: selectedBank?.label,
                currencyTypeId: selectedBankCurrencyType?.value,
                currencyTypeName: selectedBankCurrencyType?.label,
                iban: iban,
                companyBankId: Helpers.generateUUID(),
                isSelected: false,
            }

            setCompanyBanks([...companyBanks, o])
        }
        else {
            setCompanyBanks(companyBanks.map(function (x) {
                if (x.companyBankId == companyBankId) {
                    x.accountNo = accountNo;
                    x.bankId = selectedBank?.value;
                    x.bankName = selectedBank?.label;
                    x.currencyTypeId = selectedBankCurrencyType?.value;
                    x.currencyTypeName = selectedBankCurrencyType?.label;
                    x.iban = iban;
                    x.isSelected = false;
                }

                return x;
            }))
        }

        setCompanyBankId('');
        setIban('');
        setSelectedBank(undefined);
        setAccountNo('');
        setSelectedBankCurrencyType(undefined);
        setIsOpen(false);
        scrollTo();
    }

    const cancelAdding = () => {
        if (!isOpen) {
            setIsOpen(true);
            scrollTo();
            return;
        }

        setCompanyBankId('');
        setIban('');
        setSelectedBank(undefined);
        setAccountNo('');
        setSelectedBankCurrencyType(undefined);
        setIsOpen(false);
        scrollTo();
    }

    const scrollTo = () => {
        var headerOffset = 120;
        var elementPosition = banksInformationsRef.current.getBoundingClientRect().top;
        var offsetPosition = elementPosition + window.pageYOffset - headerOffset;

        window.scrollTo({
            top: offsetPosition,
            behavior: "smooth"
        });
    }

    const setUpdateItem = () => {
        var o = companyBanks.filter(x => x.isSelected)[0];

        setCompanyBankId(o.companyBankId);

        setIban(o.iban);

        if (o.bankId)
            setSelectedBank({ label: o.bankName + '', value: o.bankId });

        setAccountNo(o.accountNo);

        if (o.currencyTypeId)
            setSelectedBankCurrencyType({ label: o.currencyTypeName + '', value: o.currencyTypeId });

        setIsOpen(true);
        scrollTo();
    }

    const deleteItems = () => {
        setCompanyBanks(companyBanks.filter(x => !x.isSelected));
    }

    const selectAll = () => {
        var isAllSelected = companyBanks.length == companyBanks.filter(x => x.isSelected).length;

        setCompanyBanks(companyBanks.map(function (x) {
            x.isSelected = !isAllSelected;
            return x;
        }))
    }

    const setItemSelected = (_id: string) => {
        setCompanyBanks(companyBanks.map(function (x) {
            if (x.companyBankId == _id)
                x.isSelected = !x.isSelected;
            return x;
        }))
    }

    return (
        <div className='containerPart' ref={banksInformationsRef}>
            <KTCard className="ebbe-card mt-10">
                <KTCardBody>
                    <h4 className="mb-10 text-black">Banka Bilgileri</h4>

                    {
                        isOpen && (
                            <React.Fragment>
                                <div className='row'>
                                    <div className="col-md-4">
                                        <div>
                                            <label htmlFor="exampleFormControlInput1" className="form-label">IBAN No</label>
                                            <input onKeyUp={onIbanChange} value={iban} onChange={(e) => setIban(e.target.value)} style={{ border: '1px solid #F1F1F4' }} type={'text'} className="form-control form-control-solid" />
                                        </div>

                                        <div className="mt-5">
                                            <label htmlFor="exampleFormControlInput1" className="form-label">Döviz Cinsi</label>

                                            <CustomSingleSelect
                                                selectedValue={selectedBankCurrencyType}
                                                onChange={setSelectedBankCurrencyType}
                                                onMenuOpen={() => ConstantService.getConstantList('CURRENCY')}
                                                labelName='additionalValue1'
                                                valueName='constantId'
                                            />
                                        </div>
                                    </div>
                                    <div className="col-md-4">
                                        <div>
                                            <label htmlFor="exampleFormControlInput1" className="form-label">Banka Adı</label>

                                            <CustomSingleSelect
                                                selectedValue={selectedBank}
                                                onChange={setSelectedBank}
                                                onMenuOpen={() => ConstantService.getConstantList('BANK', undefined, undefined)}
                                                labelName='value'
                                                valueName='constantId'
                                            />
                                        </div>
                                    </div>
                                    <div className="col-md-4">
                                        <div>
                                            <label htmlFor="exampleFormControlInput1" className="form-label">Hesap No</label>
                                            <input value={accountNo} onChange={(e) => setAccountNo(e.target.value)} style={{ border: '1px solid #F1F1F4' }} type={'text'} className="form-control form-control-solid" />
                                        </div>
                                    </div>
                                </div>

                                <div className="row mt-5">
                                    <div className="col-md-12">
                                        <Box alignItems="flex-end">
                                            <Box onClick={saveItem} className="actionIcon p-2 bg-success" justifyContent="center" flexDirection="row" borderRadius="4px">
                                                <Box mr="5px" justifyContent="center">
                                                    <i className="text-white fa fa-check" />
                                                </Box>
                                                <Box justifyContent="center">
                                                    <span style={{ fontWeight: 600 }} className="text-white">Kaydet</span>
                                                </Box>
                                            </Box>
                                        </Box>
                                    </div>
                                </div>

                                <Box className='ebbe-hr m-0 mt-5'>&nbsp;</Box>
                            </React.Fragment>
                        )
                    }

                    <Box className={isOpen ? "mt-5" : ""} flexDirection="row">
                        <Box onClick={!canBeEdited ? undefined : cancelAdding} className={"actionIcon p-2 " + (!isOpen ? "bg-success" : "")} bg={isOpen ? 'orange' : undefined} opacity={!canBeEdited ? "0.5" : "1"} justifyContent="center" flexDirection="row" borderRadius="4px">
                            <Box mr="5px" justifyContent="center">
                                <i className={"text-white fa " + (!isOpen ? 'fa-plus' : 'fa-times')} />
                            </Box>
                            <Box justifyContent="center">
                                <span style={{ fontWeight: 600 }} className="text-white">{!isOpen ? 'Ekle' : 'İptal Et'}</span>
                            </Box>
                        </Box>

                        <Box onClick={!canBeEdited ? undefined : companyBanks.filter(x => x.isSelected).length == 1 ? setUpdateItem : undefined} opacity={!canBeEdited ? "0.5" : companyBanks.filter(x => x.isSelected).length == 1 ? "1" : "0.5"} ml="10px" className="actionIcon p-2 bg-primary" justifyContent="center" flexDirection="row" borderRadius="4px">
                            <Box mr="5px" justifyContent="center">
                                <i className="text-white fa fa-edit" />
                            </Box>
                            <Box justifyContent="center">
                                <span style={{ fontWeight: 600 }} className="text-white">Güncelle</span>
                            </Box>
                        </Box>


                        <Box onClick={!canBeEdited ? undefined : companyBanks.filter(x => x.isSelected).length > 0 ? () => dispatch(storeAreYouSureModalCallback(deleteItems)) : undefined} opacity={!canBeEdited ? "0.5" : companyBanks.filter(x => x.isSelected).length > 0 ? "1" : "0.5"} ml="10px" className="actionIcon p-2 bg-danger" justifyContent="center" flexDirection="row" borderRadius="4px">
                            <Box mr="5px" justifyContent="center">
                                <i className="text-white fa fa-trash" />
                            </Box>
                            <Box justifyContent="center">
                                <span style={{ fontWeight: 600 }} className="text-white">Sil</span>
                            </Box>
                        </Box>
                    </Box>

                    <div className="row mt-5">
                        <div className="col-md-12">
                            <div className='table-responsive'>
                                <table id='kt_table_users' className='table align-middle table-row-dashed dataTable no-footer'>
                                    <thead>
                                        <tr className='text-start text-muted fw-bolder text-uppercase'>
                                            <th style={{ width: 1 }}>
                                                <div className='d-flex'>
                                                    <label className='form-check form-check-sm form-check-custom form-check-solid me-5'>
                                                        <input disabled={!canBeEdited} onChange={selectAll} className='form-check-input' type='checkbox' checked={companyBanks.filter(x => x.isSelected).length > 0 && companyBanks.filter(x => x.isSelected).length == companyBanks.length} />
                                                    </label>
                                                </div>
                                            </th>
                                            <th>IBAN No</th>
                                            <th>Banka Adı</th>
                                            <th>Hesap No</th>
                                            <th>Döviz Cinsi</th>
                                        </tr>
                                    </thead>
                                    <tbody className='text-gray-600 fw-bold'>
                                        {
                                            companyBanks.length == 0 && (
                                                <tr>
                                                    <td className="text-center" colSpan={99}>Kayıt bulunamadı.</td>
                                                </tr>
                                            )
                                        }
                                        {
                                            companyBanks.map((item, index) =>
                                                <tr>
                                                    <td style={{ width: 1 }}>
                                                        <div className='d-flex'>
                                                            <label className='form-check form-check-sm form-check-custom form-check-solid me-5'>
                                                                <input disabled={!canBeEdited} onChange={() => setItemSelected(item.companyBankId)} className='form-check-input' type='checkbox' checked={item.isSelected} />
                                                            </label>
                                                        </div>
                                                    </td>
                                                    <td>{item.iban}</td>
                                                    <td>{item.bankName}</td>
                                                    <td>{item.accountNo}</td>
                                                    <td>{item.currencyTypeName}</td>
                                                </tr>
                                            )
                                        }
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </KTCardBody>
            </KTCard>
        </div>
    )
}

export default BanksInformations;